import Util from '../../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation DeactivateSlackIntegrationMutation($input: DeactivateSlackIntegrationInput!) {
		deactivateSlackIntegration(input: $input) {
			company {
				newSlackEnabled
				slackEnabled
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
